import { Navigate } from 'react-router-dom';
import { usePermissions } from '@/context/PermissionContext';
import { permissionKeys } from '@/utility';

export function NotesIndexRedirect() {
  const { permissions } = usePermissions();
  const target = permissions.has(permissionKeys.hr_notes.read)
    ? 'admin'
    : 'employee';

  return <Navigate to={target} />;
}
